declare namespace $ {

	export class $giper_balls_lines extends $giper_balls_game {
		add_new( ): any
		title( ): string
		auto( ): readonly(any)[]
		cell_start( next?: readonly(any)[] ): readonly(any)[]
	}
	
}

//# sourceMappingURL=lines.view.tree.d.ts.map